import { fromJS } from 'immutable';

export default {
    setSDM17SPGs: (state, products) => {
        return state.setIn(['list'], fromJS(products)).set('initialized', true);
    },
    updateSDM17SPGs: (state, products) => {
        return state.mergeIn(['list'], fromJS(products));
    },
    setSDM17SPGDetails: (state, productId, product) => {
        return state.setIn(['list', productId], fromJS(product));
    },
    updateSDM17SPGStatus: (state, productId, status) => {
        return state.setIn(['list', productId, 'state'], status);
    },
    switchSDM17SPGMaster: (state, productId, masterId) => {
        return state.setIn(['list', productId, 'userMasterId'], masterId);
    },
    dissociateUserFromSDM17SPG: (state, productId, userId) => {
        if (state.getIn(['list', productId, 'userMasterId']) === userId) {
            state = state.deleteIn(['list', productId, 'userMasterId']);
        }
        return state.deleteIn(['list', productId, 'usersList', state.getIn(['list', productId, 'usersList']).findIndex(i => i === userId)]);
    },
    dissociateUserFromSDM17SPGAndSwitchMaster: (state, productId, userId, masterId) => {
        state = state.setIn(['list', productId, 'userMasterId'], masterId);
        return state.deleteIn(['list', productId, 'usersList', state.getIn(['list', productId, 'usersList']).findIndex(i => i === userId)]);
    }
};



// WEBPACK FOOTER //
// ./environments/myfhe/data/SDM17SPG/core.js